import React from 'react'

const ProtectedIcon = () => (
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_1_20858)">
      <rect x="10" y="12" width="118" height="118" rx="59" fill="#EAEFFF" />
    </g>
    <rect
      x="10.5"
      y="12.5"
      width="117"
      height="117"
      rx="58.5"
      stroke="url(#paint0_linear_1_20858)"
    />
    <g opacity="0.6" filter="url(#filter1_f_1_20858)" style={{ mixBlendMode: 'color-dodge' }}>
      <path
        d="M51.1434 127.999C51.1434 127.999 63.499 85.9994 57.7828 80.1343C51.208 73.3883 10.4993 81.4639 10.4993 81.4639C16.6432 108.148 28.4584 118.692 51.1434 127.999Z"
        fill="#8FB6FF"
      />
    </g>
    <path
      d="M17.7278 101.644C17.6393 101.447 17.3607 101.447 17.2722 101.644L16.2944 103.809C16.2693 103.864 16.2249 103.908 16.1694 103.933L14.0045 104.911C13.8083 105 13.8083 105.278 14.0045 105.367L16.1694 106.345C16.2249 106.37 16.2693 106.414 16.2944 106.47L17.2722 108.635C17.3607 108.831 17.6393 108.831 17.7278 108.635L18.7056 106.47C18.7307 106.414 18.7751 106.37 18.8306 106.345L20.9955 105.367C21.1917 105.278 21.1917 105 20.9955 104.911L18.8306 103.933C18.7751 103.908 18.7307 103.864 18.7056 103.809L17.7278 101.644Z"
      fill="#151B56"
    />
    <path
      d="M28.6823 83.5427C28.6114 83.3858 28.3886 83.3858 28.3177 83.5427L27.9088 84.448C27.8888 84.4924 27.8533 84.5279 27.8089 84.5479L26.9036 84.9568C26.7467 85.0277 26.7467 85.2505 26.9036 85.3214L27.8089 85.7303C27.8533 85.7503 27.8888 85.7858 27.9088 85.8302L28.3177 86.7355C28.3886 86.8924 28.6114 86.8924 28.6823 86.7355L29.0912 85.8302C29.1112 85.7858 29.1467 85.7503 29.1911 85.7303L30.0964 85.3214C30.2533 85.2505 30.2533 85.0277 30.0964 84.9568L29.1911 84.5479C29.1467 84.5279 29.1112 84.4924 29.0912 84.448L28.6823 83.5427Z"
      fill="#151B56"
    />
    <path
      d="M35.7278 107.635C35.6393 107.831 35.3607 107.831 35.2722 107.635L34.6055 106.159C34.5804 106.103 34.536 106.059 34.4806 106.034L33.0045 105.367C32.8083 105.278 32.8083 105 33.0045 104.911L34.4806 104.245C34.536 104.22 34.5804 104.175 34.6055 104.12L35.2722 102.644C35.3607 102.447 35.6393 102.447 35.7278 102.644L36.3945 104.12C36.4196 104.175 36.464 104.22 36.5194 104.245L37.9955 104.911C38.1917 105 38.1917 105.278 37.9955 105.367L36.5194 106.034C36.464 106.059 36.4196 106.103 36.3945 106.159L35.7278 107.635Z"
      fill="#151B56"
    />
    <g opacity="0.6" filter="url(#filter2_f_1_20858)" style={{ mixBlendMode: 'color-dodge' }}>
      <path
        d="M84.0752 9L69.5 65L130.5 55.6667C123.482 28.9074 109.987 18.3333 84.0752 9Z"
        fill="#8FB6FF"
      />
    </g>
    <path
      d="M101.589 28.0179C101.943 27.2333 103.057 27.2333 103.411 28.0179L105.145 31.8556C105.245 32.0775 105.423 32.2551 105.644 32.3553L109.482 34.0886C110.267 34.443 110.267 35.557 109.482 35.9114L105.644 37.6447C105.423 37.7449 105.245 37.9225 105.145 38.1444L103.411 41.9821C103.057 42.7667 101.943 42.7667 101.589 41.9821L99.8553 38.1444C99.7551 37.9225 99.5775 37.7449 99.3556 37.6447L95.5179 35.9114C94.7333 35.557 94.7333 34.443 95.5179 34.0886L99.3556 32.3553C99.5775 32.2551 99.7551 32.0775 99.8553 31.8556L101.589 28.0179Z"
      fill="#151B56"
    />
    <path
      d="M123.272 39.5045C123.361 39.3083 123.639 39.3083 123.728 39.5045L124.395 40.9806C124.42 41.036 124.464 41.0804 124.519 41.1055L125.996 41.7722C126.192 41.8607 126.192 42.1393 125.996 42.2278L124.519 42.8945C124.464 42.9196 124.42 42.964 124.395 43.0194L123.728 44.4955C123.639 44.6917 123.361 44.6917 123.272 44.4955L122.605 43.0194C122.58 42.964 122.536 42.9196 122.481 42.8945L121.004 42.2278C120.808 42.1393 120.808 41.8607 121.004 41.7722L122.481 41.1055C122.536 41.0804 122.58 41.036 122.605 40.9806L123.272 39.5045Z"
      fill="#151B56"
    />
    <path
      d="M112.318 20.4036C112.389 20.2467 112.611 20.2467 112.682 20.4036L113.091 21.3089C113.111 21.3533 113.147 21.3888 113.191 21.4088L114.096 21.8177C114.253 21.8886 114.253 22.1114 114.096 22.1823L113.191 22.5912C113.147 22.6112 113.111 22.6467 113.091 22.6911L112.682 23.5964C112.611 23.7533 112.389 23.7533 112.318 23.5964L111.909 22.6911C111.889 22.6467 111.853 22.6112 111.809 22.5912L110.904 22.1823C110.747 22.1114 110.747 21.8886 110.904 21.8177L111.809 21.4088C111.853 21.3888 111.889 21.3533 111.909 21.3089L112.318 20.4036Z"
      fill="#151B56"
    />
    <path
      d="M91.6823 26.4036C91.6114 26.2467 91.3886 26.2467 91.3177 26.4036L90.9088 27.3089C90.8888 27.3533 90.8533 27.3888 90.8089 27.4088L89.9036 27.8177C89.7467 27.8886 89.7467 28.1114 89.9036 28.1823L90.8089 28.5912C90.8533 28.6112 90.8888 28.6467 90.9088 28.6911L91.3177 29.5964C91.3886 29.7533 91.6114 29.7533 91.6823 29.5964L92.0912 28.6911C92.1112 28.6467 92.1467 28.6112 92.1911 28.5912L93.0964 28.1823C93.2533 28.1114 93.2533 27.8886 93.0964 27.8177L92.1911 27.4088C92.1467 27.3888 92.1112 27.3533 92.0912 27.3089L91.6823 26.4036Z"
      fill="#151B56"
    />
    <g opacity="0.06" filter="url(#filter3_d_1_20858)">
      <path
        d="M91.9752 43.6104L73.0883 36.5405C71.131 35.8198 67.9374 35.8198 65.98 36.5405L47.0932 43.6104C43.4532 44.9832 40.5 49.2389 40.5 53.117V80.9161C40.5 83.696 42.32 87.3682 44.5521 89.0155L63.4389 103.121C66.7698 105.626 72.2299 105.626 75.5608 103.121L94.4476 89.0155C96.6797 87.3339 98.4997 83.696 98.4997 80.9161V53.117C98.534 49.2389 95.5808 44.9832 91.9752 43.6104ZM72.0925 73.4687V82.4948C72.0925 83.9019 70.9249 85.0688 69.517 85.0688C68.1091 85.0688 66.9415 83.9019 66.9415 82.4948V73.4687C63.4732 72.3704 60.9321 69.1444 60.9321 65.3349C60.9321 60.5987 64.7781 56.7549 69.517 56.7549C74.2559 56.7549 78.1019 60.5987 78.1019 65.3349C78.1019 69.1787 75.5608 72.3704 72.0925 73.4687Z"
        fill="#151B56"
      />
    </g>
    <g opacity="0.1" filter="url(#filter4_d_1_20858)">
      <path
        d="M88.1001 48.2869L72.4697 42.4465C70.8498 41.8512 68.2068 41.8512 66.5869 42.4465L50.9565 48.2869C47.944 49.4209 45.5 52.9365 45.5 56.1401V79.1046C45.5 81.401 47.0062 84.4346 48.8534 85.7954L64.4839 97.4478C67.2406 99.5174 71.7592 99.5174 74.5158 97.4478L90.1463 85.7954C91.9935 84.4062 93.4998 81.401 93.4998 79.1046V56.1401C93.5282 52.9365 91.0841 49.4209 88.1001 48.2869ZM71.6455 72.9524V80.4087C71.6455 81.5711 70.6793 82.5351 69.5141 82.5351C68.3489 82.5351 67.3827 81.5711 67.3827 80.4087V72.9524C64.5123 72.0451 62.4093 69.3801 62.4093 66.2331C62.4093 62.3207 65.5923 59.1454 69.5141 59.1454C73.4359 59.1454 76.6188 62.3207 76.6188 66.2331C76.6188 69.4085 74.5158 72.0451 71.6455 72.9524Z"
        fill="#151B56"
      />
    </g>
    <g filter="url(#filter5_d_1_20858)">
      <path
        d="M84.2148 53.3825L71.8398 48.7475C70.5573 48.275 68.4648 48.275 67.1823 48.7475L54.8073 53.3825C52.4223 54.2825 50.4873 57.0725 50.4873 59.615V77.84C50.4873 79.6625 51.6798 82.07 53.1423 83.15L65.5173 92.3975C67.6998 94.04 71.2773 94.04 73.4598 92.3975L85.8348 83.15C87.2973 82.0475 88.4898 79.6625 88.4898 77.84V59.615C88.5123 57.0725 86.5773 54.2825 84.2148 53.3825ZM71.1873 72.9575V78.875C71.1873 79.7975 70.4223 80.5625 69.4998 80.5625C68.5773 80.5625 67.8123 79.7975 67.8123 78.875V72.9575C65.5398 72.2375 63.8748 70.1225 63.8748 67.625C63.8748 64.52 66.3948 62 69.4998 62C72.6048 62 75.1248 64.52 75.1248 67.625C75.1248 70.145 73.4598 72.2375 71.1873 72.9575Z"
        fill="#151B56"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1_20858"
        x="10"
        y="12"
        width="118"
        height="122"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.854902 0 0 0 0 0.898039 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1_20858" />
      </filter>
      <filter
        id="filter1_f_1_20858"
        x="1.49902"
        y="68.4459"
        width="66.7939"
        height="68.5535"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_1_20858" />
      </filter>
      <filter
        id="filter2_f_1_20858"
        x="60.5"
        y="0"
        width="79"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_1_20858" />
      </filter>
      <filter
        id="filter3_d_1_20858"
        x="36.5"
        y="32"
        width="66"
        height="77"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0823529 0 0 0 0 0.105882 0 0 0 0 0.337255 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_20858" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_20858" result="shape" />
      </filter>
      <filter
        id="filter4_d_1_20858"
        x="35.5"
        y="32"
        width="68"
        height="77"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0823529 0 0 0 0 0.105882 0 0 0 0 0.337255 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_20858" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_20858" result="shape" />
      </filter>
      <filter
        id="filter5_d_1_20858"
        x="32.5"
        y="34"
        width="74"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0823529 0 0 0 0 0.105882 0 0 0 0 0.337255 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_20858" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_20858" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_1_20858"
        x1="6.5"
        y1="9"
        x2="130"
        y2="117"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE5FF" />
        <stop offset="0.490385" stopColor="#DAE5FF" stopOpacity="0" />
        <stop offset="1" stopColor="#DAE5FF" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProtectedIcon
